import styled from 'styled-components';

export const Container = styled.div`
  padding: 25px;
  padding-right: 50px;
  box-sizing: border-box;
`;

export const ContainerMobile = styled.div`
  box-sizing: border-box;
  padding-bottom: 150px;
`;
